/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OwnerBountyResponseDtoFromJSON, OwnerBountyResponseDtoToJSON, } from './OwnerBountyResponseDto';
/**
 * Check if a given object implements the OwnerBountyResponseDtoPageResponse interface.
 */
export function instanceOfOwnerBountyResponseDtoPageResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function OwnerBountyResponseDtoPageResponseFromJSON(json) {
    return OwnerBountyResponseDtoPageResponseFromJSONTyped(json, false);
}
export function OwnerBountyResponseDtoPageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': !exists(json, 'count') ? undefined : json['count'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(OwnerBountyResponseDtoFromJSON)),
    };
}
export function OwnerBountyResponseDtoPageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'totalCount': value.totalCount,
        'page': value.page,
        'pageSize': value.pageSize,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(OwnerBountyResponseDtoToJSON)),
    };
}
